import { render } from "./Detail.vue?vue&type=template&id=697ec45c"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=697ec45c&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__